<template>
  <Password
    v-model="password1"
    ref="password1Ref"
    :title="$t('SaquePw.NewWithdrawalPw')"
  />
  <Password
    v-model="password2"
    ref="password2Ref"
    :title="$t('SaquePw.ConfirmWithdrawalPw')"
  />
  <div class="w-full px-4">
    <van-button
      @click="handleNext"
      :class="['!mt-4', isSame ? 'primaryBtn' : 'primaryBtn_transparent']"
      :disabled="!isSame"
      >{{ $t("Common.Confirm") }}</van-button
    >
  </div>
</template>

<script setup lang="ts">
import Password from "./Password.vue";
import { setWithdrawalPassword } from "@/api/saque";
import { encryptPassword } from "@/utils";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const password1 = ref("");
const password2 = ref("");
const password1Ref = ref<any>(null);
const password2Ref = ref<any>(null);
const emit = defineEmits(["update:modelValue", "next"]);
const handleNext = async () => {
  if (password1.value !== password2.value) {
    showToast({
      message: t("SaquePw.PwMismatchPrompt"),
    });
    return;
  }
  const res = await setWithdrawalPassword({
    withdrawalPassword: encryptPassword(password1.value),
  });
  if (res.code === 1) {
    emit("next");
  }
};

watch(password1, (newVal) => {
  if (newVal.length === 6) {
    password2Ref.value?.focusInput();
  }
});

onMounted(() => {
  password1Ref.value?.focusInput();
});
const isSame = computed(() => {
  return password1.value.length === 6 && password2.value.length === 6;
});
</script>

<style lang="scss" scoped></style>
